import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { getDb } from '../lib/firebase';
import type { JobDoc } from '../lib/types';

export function useJob(jobId: string | null): JobDoc | null {
  const [job, setJob] = useState<JobDoc | null>(null);

  useEffect(() => {
    if (!jobId) {
      setJob(null);
      return;
    }
    const db = getDb();
    const ref = doc(db, 'jobs', jobId);
    const off = onSnapshot(
      ref,
      (snap) => {
        setJob(snap.exists() ? (snap.data() as JobDoc) : null);
      },
      (err) => {
        console.error('useJob snapshot error', err);
      },
    );
    return () => off();
  }, [jobId]);

  return job;
}
